var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Fragment",
    [
      _c(
        "div",
        { staticClass: "page-container saved-outfits-container" },
        [
          _c("transition", { attrs: { name: "fade" } }, [
            !_vm.savedOutfits || _vm.savedOutfitsDataLoading
              ? _c(
                  "div",
                  { key: 1, staticClass: "loading-overlay" },
                  [_c("loader")],
                  1
                )
              : _c(
                  "div",
                  { key: "2", staticStyle: { "padding-bottom": "50px" } },
                  [
                    _vm.savedOutfits.length < 1
                      ? _c("div", [
                          _c("div", { staticClass: "no-results-message" }, [
                            _vm._v(
                              "\n                        You currently don't have any saved items " +
                                _vm._s(
                                  _vm.savedOutfitsCount > 0
                                    ? "with those filters"
                                    : ""
                                ) +
                                "\n                    "
                            )
                          ])
                        ])
                      : _c(
                          "div",
                          { staticClass: "saved-items-container" },
                          [
                            _vm._l(_vm.savedOutfits, function(outfit) {
                              return _c(
                                "div",
                                {
                                  key: outfit.outfit_id,
                                  staticClass: "saved-outfit-container"
                                },
                                [
                                  _c("div", { staticClass: "outfit-header" }, [
                                    _c("span", { staticClass: "count" }, [
                                      _vm._v(
                                        _vm._s(outfit.products.length) +
                                          " items"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "remove",
                                        on: {
                                          click: function() {
                                            return _vm.openUnsaveModal(outfit)
                                          }
                                        }
                                      },
                                      [_vm._v("Remove")]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "grid-items" }, [
                                    _c(
                                      "div",
                                      { staticClass: "grid-items-wrapper" },
                                      _vm._l(outfit.products, function(
                                        product
                                      ) {
                                        return _c("div", {
                                          key:
                                            product.product_id +
                                            "_" +
                                            product.product_option_value_id,
                                          staticClass: "grid-item",
                                          style: {
                                            backgroundImage:
                                              "url('" +
                                              decodeURI(
                                                product.product_image_url
                                              ) +
                                              "')"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return function() {
                                                return _vm.handleItemImageClick(
                                                  product,
                                                  outfit
                                                )
                                              }.apply(null, arguments)
                                            }
                                          }
                                        })
                                      }),
                                      0
                                    )
                                  ])
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "infinite-loading",
                              {
                                ref: "infiniteLoading",
                                attrs: { spinner: "waveDots" },
                                on: { infinite: _vm.getMoreOutfits }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "no-more" },
                                    slot: "no-more"
                                  },
                                  [_vm._v("No more outfits to show!")]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  attrs: { slot: "no-results" },
                                  slot: "no-results"
                                })
                              ]
                            )
                          ],
                          2
                        )
                  ]
                )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.unsaveModalOpened
        ? _c("unsave-item-modal", {
            attrs: {
              itemType: "outfit",
              confirm: _vm.unsaveOutfit,
              close: _vm.closeUnsaveModal,
              loading: _vm.unsaveLoading
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5647a256", { render: render, staticRenderFns: staticRenderFns })
  }
}